import type { Key } from '@/root/shared-hooks/useGetTranslations/useGetTranslations'

const ERROR_KEYS: Record<string, Key> = {
  FAILED_TO_ALLOCATE_PAX_INVENTORY: 'failedToAllocatePaxInventory',
  FAILED_TO_ALLOCATE_CAR_DECK_INVENTORY: 'vehicleNoDeckSpace',
  FAILED_TO_ALLOCATE_CAR_DECK_INVENTORY_BY_WEIGHT: 'vehicleNoDeckSpace',
  INVALID_PERSONAL_IDENTIFICATION_NUMBER: 'INVALID_PERSONAL_IDENTIFICATION_NUMBER',
}

/** The message shown when creating, updating or confirming a reservation fails with the given API code. */
export const getReservationErrorKey = (apiCode: string | undefined): Key =>
  (apiCode && ERROR_KEYS[apiCode]) || 'commonNotificationErrorDesc'
